import { toast } from "@skydio/rivet-ui";

import type React from "react";
import type { PayloadError } from "relay-runtime";

export interface MutationResponse {
  readonly errors: ReadonlyArray<string | null> | null;
}

interface displayMutationResultsArgs<U extends MutationResponse> {
  successMessage?: (response: U) => React.ReactNode;
  onSuccess?: (response: U) => void;
  onError?: (errors: readonly (string | null)[]) => void;
}

export const displayMutationResults =
  <T, U extends MutationResponse>(
    mutationObject: (response: T) => U | null,
    { successMessage, onSuccess, onError }: displayMutationResultsArgs<U>
  ) =>
  (response: T, errorArray?: PayloadError[] | null) => {
    const mutation = mutationObject(response);

    const errors = mutation?.errors ?? errorArray?.map(({ message }) => message);
    if (errors && errors.length > 0) {
      errors.forEach(error =>
        toast.error(error, {
          duration: 5000,
        })
      );
      if (onError) {
        onError(errors);
      }
    } else if (mutation != null) {
      if (successMessage) {
        toast.success(successMessage(mutation), {
          duration: 5000,
        });
      }
      if (onSuccess) {
        onSuccess(mutation);
      }
    } else {
      toast.error("Action failed");
      if (onError) {
        onError(["Action failed"]);
      }
    }
  };
